// Icon: material-symbols:language
// Slug: Internationalizes a value.
// Description: Internationalizes a value.

import { action } from '@engine'

action({
  name: 'intl',
  apply(
    { error },
    type: string,
    value: any,
    options: Record<string, any>,
    locales?: string | string[],
  ) {
    const locale = locales || navigator.language || 'en-US'
    switch (type) {
      case 'datetime': {
        const date = value instanceof Date ? value : new Date(value)
        if (Number.isNaN(date.getTime())) {
          throw error('IntlInvalidDate', { value })
        }
        return new Intl.DateTimeFormat(
          locale,
          options as Intl.DateTimeFormatOptions,
        ).format(date)
      }
      case 'number':
        return new Intl.NumberFormat(locale, options).format(
          typeof value === 'number' ? value : parseFloat(value),
        )
      case 'pluralRules':
        return new Intl.PluralRules(
          locale,
          options as Intl.PluralRulesOptions,
        ).select(Number(value))
      case 'relativeTime': {
        const unit = (options as any).unit?.[0] ?? 'day'
        return new Intl.RelativeTimeFormat(
          locale,
          options as Intl.RelativeTimeFormatOptions,
        ).format(Number(value), unit as Intl.RelativeTimeFormatUnit)
      }
      case 'list':
        return new Intl.ListFormat(
          locale,
          options as Intl.ListFormatOptions,
        ).format(Array.isArray(value) ? value.map(String) : [String(value)])
      case 'displayNames': {
        const displayType = (options as any).type || 'language'
        const opts = { ...options, type: displayType } as Record<string, any>
        return new Intl.DisplayNames(
          locale,
          opts as Intl.DisplayNamesOptions,
        ).of(String(value))
      }
      default:
        throw error('IntlTypeNotSupported', { type })
    }
  },
})
